var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkblue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 809,
    height: 70,
    viewBox: "0 0 809 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M809 0H-2V70H809V0Z",
    fill: "#032D45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M608 0H597V70H608V0Z",
    fill: "#032D45"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M629 0H618V70H629V0Z",
    fill: "#032D45"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M650 0H639V70H650V0Z",
    fill: "#032D45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkblue);
export default __webpack_public_path__ + "static/media/darkblue.36b3ef12c3025056e1eb60651078bbb9.svg";
export { ForwardRef as ReactComponent };